import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { PhasrRecommendationsGridBaseDataProvider } from '../dataProvider/PhasrRecommendationsGridBaseDataProvider';

export class PhasrRecommendationsGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PhasrRecommendationsGridBaseDataProvider);
  }
}
